import { cn } from '@/lib/utils'
import { useState } from 'react'

interface OrgLogoProps {
  logoUrl: string | null
  orgName: string | null
  size?: 'sm' | 'lg'
}

/**
 * The client org's own logo, with a branded fallback (initial-letter badge)
 * when there is no logo_url yet or the URL 404s -- portal.service's
 * PortalOrganizationInfo has no way to signal "logo failed", so the failure
 * is only ever discovered client-side via the <img> onError.
 */
export function OrgLogo({ logoUrl, orgName, size = 'sm' }: OrgLogoProps) {
  const [loadFailed, setLoadFailed] = useState(false)
  const initial = orgName?.charAt(0)?.toUpperCase() || 'P'

  if (logoUrl && !loadFailed) {
    return (
      <img
        src={logoUrl}
        alt={orgName || ''}
        onError={() => setLoadFailed(true)}
        className={cn(
          'object-contain object-left',
          size === 'lg' ? 'h-12 w-auto max-w-[200px]' : 'h-8 w-auto max-w-[160px]',
        )}
      />
    )
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg bg-blue-100',
        size === 'lg' ? 'h-12 w-12' : 'h-8 w-8',
      )}
    >
      <span className={cn('font-bold text-blue-600', size === 'lg' ? 'text-lg' : 'text-sm')}>
        {initial}
      </span>
    </div>
  )
}
